import React, { useState } from 'react';

const TerminalChallenge = ({ challenge }) => {
  const [input, setInput] = useState('');
  const [history, setHistory] = useState([challenge.description]);
  const [userSolution, setUserSolution] = useState(''); // To track user input for the flag
  const [isCorrect, setIsCorrect] = useState(false); // To track correctness
  const [hasSubmitted, setHasSubmitted] = useState(false); // To track flag submission

  const handleCommand = (command) => {
    let output = '';
    if (command === 'clear') {
      setHistory([]); // Clear history
      return;
    } else if (challenge.commands[command]) {
      output = challenge.commands[command]; // Execute valid command
    } else {
      output = `Command not found: ${command}`;
    }

    setHistory((prevHistory) => [...prevHistory, `> ${command}`, output]);
  };

  const handleSubmitCommand = (e) => {
    e.preventDefault();
    if (input.trim()) {
      handleCommand(input.trim());
    }
    setInput('');
  };

  const handleSubmitFlag = (e) => {
    e.preventDefault();
    setHasSubmitted(true); // Mark flag submission

    // Check if the solution is correct
    if (userSolution === challenge.solution) {
      setIsCorrect(true);
    } else {
      setIsCorrect(false);
    }
  };

  return (
    <div className="bg-gray-900 text-green-400 font-mono p-4 rounded-lg shadow-lg min-h-[300px] border-2 border-cyberBlue">
      {/* Terminal history */}
      <div className="overflow-y-auto h-64 p-2">
        {history.map((entry, index) => (
          <p key={index} className="text-green-400">{entry}</p>
        ))}
      </div>

      {/* Command input */}
      <form onSubmit={handleSubmitCommand} className="flex items-center mt-4">
        <span className="text-green-400">{'>'}</span>
        <input
          type="text"
          className="bg-gray-900 text-green-400 outline-none w-full ml-2"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          autoFocus
        />
      </form>

      {/* Flag submission form */}
      <form onSubmit={handleSubmitFlag} className="mt-4">
        <input
          type="text"
          value={userSolution}
          onChange={(e) => setUserSolution(e.target.value)}
          className="bg-gray-800 text-white p-2 rounded-lg"
          placeholder="Enter the flag"
        />
        <button type="submit" className="bg-cyberBlue text-black p-2 rounded-lg ml-2">
          Submit Flag
        </button>
      </form>

      {/* Show feedback after the form has been submitted */}
      {hasSubmitted && (
        isCorrect ? (
          <p className="text-green-500 mt-2">Correct! You've found the flag.</p>
        ) : (
          <p className="text-red-500 mt-2">Incorrect. Try again.</p>
        )
      )}
    </div>
  );
};

export default TerminalChallenge;
